"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _Offer = _interopRequireDefault(require("../../components/Offer"));
var _ErrorPage = _interopRequireDefault(require("../../components/ErrorPage"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Footer = _interopRequireDefault(require("../../components/Footer"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _api = require("../../api");
var _appConfigHelper = require("../../util/appConfigHelper");
var _store = require("../../redux/store");
var _toolkit = require("@reduxjs/toolkit");
var _offerSlice = require("../../redux/offerSlice");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _orderSlice = require("../../redux/orderSlice");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _withPaymentFinalizationHandler = _interopRequireDefault(require("../withPaymentFinalizationHandler"));
var _StyledOfferContainer = require("./StyledOfferContainer");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OfferContainer = _ref => {
  let {
    adyenConfiguration: adyenConfigurationProp,
    couponCode: couponCodeProp,
    isCheckout = false,
    offerId: offerIdProp,
    onSuccess,
    onRedeemClick
  } = _ref;
  const [errorMsg, setErrorMsg] = (0, _react.useState)();
  const dispatch = (0, _store.useAppDispatch)();
  const {
    offerId: offerIdStore,
    adyenConfiguration: adyenConfigurationStore
  } = (0, _store.useAppSelector)(_publisherConfigSlice.selectPublisherConfig);
  const {
    order,
    loading: isOrderLoading,
    error: orderError
  } = (0, _store.useAppSelector)(_orderSlice.selectOrder);
  const {
    error: offerError
  } = (0, _store.useAppSelector)(_offerSlice.selectOffer);
  const offerId = offerIdProp || offerIdStore;
  const adyenConfiguration = adyenConfigurationProp || adyenConfigurationStore;
  const freeOfferPaymentMethodHandler = orderId => {
    (0, _api.getPaymentMethods)().then(paymentMethodResponse => {
      const {
        responseData: {
          paymentMethods
        }
      } = paymentMethodResponse;
      const properPaymentMethodId = paymentMethods.find(method => (0, _appConfigHelper.getData)('CLEENG_OFFER_TYPE') === 'S' ? method.methodName === 'manual' : method.methodName !== 'manual');
      if (properPaymentMethodId) {
        (0, _api.updateOrder)(orderId, {
          paymentMethodId: properPaymentMethodId.id
        });
      }
    });
  };
  const createOrderHandler = async longOfferId => {
    const resultOrderAction = await dispatch((0, _orderSlice.fetchCreateOrder)(longOfferId));
    const {
      id,
      totalPrice,
      discount: {
        applied
      }
    } = (0, _toolkit.unwrapResult)(resultOrderAction);
    if (totalPrice === 0 && !applied) {
      freeOfferPaymentMethodHandler(id);
      dispatch((0, _offerSlice.setFreeOffer)(true));
    }
    (0, _appConfigHelper.setData)('CLEENG_ORDER_ID', id);
  };
  const reuseSavedOrder = async (id, longOfferId) => {
    await dispatch((0, _orderSlice.fetchGetOrder)(id)).unwrap().then(orderResponse => {
      const {
        customerId
      } = (0, _jwtDecode.default)((0, _appConfigHelper.getData)('CLEENG_AUTH_TOKEN'));
      if (!(orderResponse.offerId === longOfferId && orderResponse.customerId === customerId) || !(orderResponse !== null && orderResponse !== void 0 && orderResponse.paymentMethodId)) {
        (0, _appConfigHelper.removeData)('CLEENG_ORDER_ID');
        createOrderHandler(longOfferId);
      }
    }).catch(() => {
      (0, _appConfigHelper.removeData)('CLEENG_ORDER_ID');
      createOrderHandler(longOfferId);
    });
  };
  const onCouponSubmit = couponCode => {
    if (couponCode === '') return;
    dispatch((0, _orderSlice.fetchUpdateCoupon)({
      id: order.id,
      couponCode
    })).unwrap().then(() => {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_COUPON_SUCCESSFUL, {
        detail: {
          coupon: couponCode,
          source: 'checkout'
        },
        order
      });
    }).catch(() => {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_COUPON_FAILED, {
        detail: {
          coupon: couponCode,
          source: 'checkout'
        }
      });
    });
  };
  (0, _react.useEffect)(() => {
    return () => {
      dispatch((0, _orderSlice.clearOrder)());
    };
  }, []);
  (0, _react.useEffect)(() => {
    dispatch((0, _publisherConfigSlice.init)({
      offerId,
      adyenConfiguration
    }));
    if (!offerId) {
      setErrorMsg('Offer not set');
      return;
    }
    const init = async () => {
      const resultOfferAction = await dispatch((0, _offerSlice.fetchOffer)(offerId));
      await dispatch((0, _offerSlice.fetchOfferV2)(offerId.split('_')[0]));
      const {
        offerId: id
      } = (0, _toolkit.unwrapResult)(resultOfferAction);
      (0, _appConfigHelper.setData)('CLEENG_OFFER_ID', id);
      (0, _appConfigHelper.setData)('CLEENG_OFFER_TYPE', id.charAt(0));
      const orderId = (0, _appConfigHelper.getData)('CLEENG_ORDER_ID');
      if (orderId) {
        await reuseSavedOrder(orderId, id);
      } else {
        await createOrderHandler(id);
      }
    };
    init();
    if (offerId === '' && !(0, _appConfigHelper.getData)('CLEENG_OFFER_ID')) {
      setErrorMsg('Offer not set');
    }
  }, [offerIdProp]);
  (0, _react.useEffect)(() => {
    if (!isOrderLoading || errorMsg || offerError || orderError) {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_LOADED, {
        order
      });
    }
  }, [isOrderLoading, errorMsg, offerError, offerError]);
  (0, _react.useEffect)(() => {
    if (couponCodeProp && order.id !== 0) {
      onCouponSubmit(couponCodeProp);
    }
  }, [couponCodeProp, order.id]);
  const errorMapping = err => {
    const errorTypes = {
      cannotPurchase: ['Offer is blocked for country'],
      offerNotExist: ["doesn't exist", 'does not exist', 'Invalid param offerId', 'Offer not set'],
      alreadyHaveAccess: ['Access already granted'],
      generalError: ['Request failed with status code 500'],
      inactive: ['inactive'],
      isNotAuth: ['']
    };
    const types = Object.keys(errorTypes);
    if (!err) return undefined;
    return types.find(type => errorTypes[type].find(item => item.includes(err) || err.includes(item)));
  };
  if (errorMsg || offerError || orderError) {
    const type = errorMapping(errorMsg || offerError || orderError);
    if (type === 'alreadyHaveAccess') {
      (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_GOOD_NEWS);
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorPage.default, {
      type: type
    });
  }
  if (isOrderLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledOfferContainer.StyledLoaderContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledOfferContainer.StyledLoaderContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Offer.default, {
    isCheckout: isCheckout,
    onCouponSubmit: onCouponSubmit,
    onPaymentComplete: onSuccess,
    onRedeemClick: onRedeemClick
  });
};
var _default = exports.default = (0, _withPaymentFinalizationHandler.default)(OfferContainer);